export default function ValidatePasswordRepeat() {
  var valid = true;
  var rfvPassRepeat = $("#rfvPassRepeat");
  var compvPassRepeat = $("#compvPassRepeat");
  var Password = $("input.tbxPass");
  var PasswordRepeat = $("input.tbxPassRepeat");
  rfvPassRepeat.hide();
  compvPassRepeat.hide();
  PasswordRepeat.removeClass("error");
  if (PasswordRepeat.val().length == 0) {
    valid = false;
    rfvPassRepeat.show();
    PasswordRepeat.addClass("error");
  } else if (Password.val().length > 0 && PasswordRepeat.val().length > 0 && Password.val() != PasswordRepeat.val()) {
    valid = false;
    compvPassRepeat.show();
    PasswordRepeat.addClass("error");
  }

  return valid;
}